__turbopack_context__.v({
  "select": "sd-yuG_select",
});
